var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-block" },
    [
      _vm.booking.type === "booking" ||
      (_vm.booking.can_upload_files && (_vm.$userIsAdmin || _vm.$userIsClient))
        ? _c(
            "h2",
            [
              _vm.booking.is_offer
                ? [_vm._v("Offer Files")]
                : [_vm._v("Booking Files")],
              _vm._v(" "),
              !_vm.booking.is_offer &&
              (_vm.booking.type === "booking" ||
                (_vm.booking.can_upload_files &&
                  (_vm.$userIsAdmin || _vm.$userIsClient)))
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { type: "submit" },
                      on: { click: _vm.handleGetFileInput },
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(" Upload Files\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.booking.is_offer &&
              (_vm.booking.type === "booking" ||
                (_vm.booking.can_upload_files &&
                  (_vm.$userIsAdmin || _vm.$userIsClient)))
                ? _c("input", {
                    ref: "fileInput",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", multiple: "" },
                    on: { change: this.handleAddBookingFiles },
                  })
                : _vm._e(),
            ],
            2
          )
        : _c(
            "h2",
            [
              _vm.booking.is_offer
                ? [_vm._v("Offer Files")]
                : [_vm._v("Booking Files")],
            ],
            2
          ),
      _vm._v(" "),
      _vm.files.length
        ? _c(
            "ul",
            { staticStyle: { padding: "0" } },
            [
              _vm._l(_vm.files, function (file) {
                return _c("booking-file-list-item", {
                  key: file.id,
                  attrs: { file: file, booking: _vm.booking },
                })
              }),
              _vm._v(" "),
              _vm.loading
                ? _c("pickstar-loading", { staticClass: "m-t-lg" })
                : _vm._e(),
            ],
            2
          )
        : _vm.loading
        ? _c("pickstar-loading", { staticClass: "m-t-lg" })
        : _c("no-results", [_vm._v("\n    There are currently no files.\n  ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }